import { render } from "./CategoriaComponent.vue?vue&type=template&id=ddaa29da&scoped=true"
import script from "./CategoriaComponent.vue?vue&type=script&lang=js"
export * from "./CategoriaComponent.vue?vue&type=script&lang=js"

import "./CategoriaComponent.vue?vue&type=style&index=0&id=ddaa29da&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ddaa29da"]])

export default __exports__